import { render } from "./FlowEdit.vue?vue&type=template&id=2177c4e2&scoped=true&ts=true"
import script from "./FlowEdit.vue?vue&type=script&lang=ts"
export * from "./FlowEdit.vue?vue&type=script&lang=ts"

import "./FlowEdit.vue?vue&type=style&index=0&id=2177c4e2&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2177c4e2"]])

export default __exports__